import React from "react";
import PropTypes from 'prop-types';
import './fotorama.dev';
import "../../../styles/fotorama.dev.css";
import $ from 'jquery';
import uniqueId from 'lodash/uniqueId';

export default class PhotoGallery extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.fotoramaParentId = uniqueId('fotorama_parent_');
        this.fotoramaRef = React.createRef();
    }

    componentDidMount() {
        this.initializeFotorama();
    }

    shouldComponentUpdate(nextProps, nextState) {
        return nextProps.imageList !== this.props.imageList;
    }

    componentDidUpdate() {
        this.initializeFotorama();
    }

    initializeFotorama() {
        const images = this.props.imageList;

        const $fotoramaDiv = $(this.fotoramaRef.current).fotorama();
        const fotorama = $fotoramaDiv.data('fotorama');
        console.log(fotorama);
        if (fotorama) {
            fotorama.load(this.props.imageList);
/*
            if (this.props.imageList.length > 0)
                fotorama.show(0);
*/
        } else {
            $(this.fotoramaRef.current).fotorama({data: this.props.imageList});
        }
    }

    render() {
        return (
            <div id={this.fotoramaParentId}>
                <div ref={this.fotoramaRef} className="fotorama" data-auto="false" data-nav="thumbs" data-allowfullscreen="true"
                     data-width={this.props.width} data-height={this.props.height}>
                </div>
            </div>
        );
    }
}

PhotoGallery.defaultProps = {
    imageList: [],
    width: 800,
    height: 600
};

PhotoGallery.propTypes = {
    imageList: PropTypes.array,
    width: PropTypes.number,
    height: PropTypes.number

};
